module.exports = __webpack_public_path__ + "img/store_Twitter_brown.1503b51b.svg";